import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GetEmployeeAdditionsDeductionsQueryVariables, ListDeductionsResponse } from '../types';

const listDeductionsQuery = gql`
  query PayrollListDeductions(
    $userId: String!
    $effectiveFrom: String!
    $effectiveTo: String!
    $payType: PayTypeFilter
  ) {
    payrollListDeductions(
      userId: $userId
      effectiveFrom: $effectiveFrom
      effectiveTo: $effectiveTo
      payType: $payType
    ) {
      data {
        data {
          id
          componentId
          componentName
          userId
          amount
          effectiveFrom
          effectiveTo
          type
          componentDetails {
            id
            name
            description
            defaultFormula
            category
            settings {
              behaviour {
                pfBehaviour {
                  includeInPfWages
                }
                ptBehaviour {
                  includeInPtWages
                }
                esiBehaviour {
                  includeInEsiWages
                }
                lwfBehaviour {
                  includeInLwfWages
                }
                taxBehaviour {
                  taxExemptionSection
                  taxDeductionBehaviour
                  taxExemptInNewRegime
                  taxExemptInOldRegime
                }
                arrearBehaviour {
                  considerInArrear
                }
                prorationBehaviour {
                  supportProration
                }
                displayBehaviour {
                  showZero
                  visibleToEmployee
                  displayName
                }
              }
              earningDetails {
                payType
              }
              deductionDetails {
                deductionType
                deductFrom
              }
              bonusDetails {
                clawbackDuration
                isTaxable
              }
              perquisiteDetails {
                isTaxable
              }
              nonPayableBenefitsDetails {
                isPartOfCTC
                visibilityToEmployee
              }
            }
            isPredefined
            isActive
            source
          }
        }
        source
      }
      code
      success
      message
    }
  }
`;

const listDeductions = (queryVariables: GetEmployeeAdditionsDeductionsQueryVariables) => {
  return graphQLApi<ListDeductionsResponse, GetEmployeeAdditionsDeductionsQueryVariables>({
    query: listDeductionsQuery,
    queryVariables,
  });
};

export default listDeductions;
